import {
  SAVE_SUBMISSION_FORM_ADMIN,
  SET_SUBMISSION_ID,
  SET_SORT_BY,
} from './constants';

export const initialState = {
  formId: -1,
  apStatus: '',
  formData: {
    title: '',
    type: 'real_wedding',
  },
  sortBy: [
    {
      id: 'createdAt',
      desc: true,
    },
  ],
};

function formReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_SUBMISSION_FORM_ADMIN:
      return {
        ...state,
        formData: action.payload,
      };

    case SET_SUBMISSION_ID:
      return {
        ...state,
        formId: action.payload,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };
    default:
      return state;
  }
}

export default formReducer;
